import { httpDelete, httpGet, httpPost, httpPut } from 'core/utils/httpClient';
import { UserCredits } from '../models/store';

export interface ScanSignedURLResponse {
  scan_id: string;
  url: string;
}

export const getUserCredits = (): Promise<{ userCredit: UserCredits }> =>
  httpGet('/plagiarism/credits');

export const getSignedURL = (file_name: string): Promise<ScanSignedURLResponse> =>
  httpGet('/plagiarism/scan/upload-url', { file_name });

export const fileUploadSuccess = (scan_id: string): Promise<{}> =>
  httpPost(`/plagiarism/scan/${scan_id}/upload-success`, {});

export const initiateScan = (scan_id: string): Promise<{}> =>
  httpPut(`/plagiarism/scan/${scan_id}/initiate-scan`, {});

export const getUserScanHistory = (pageNum: number, limit: number) =>
  httpGet('/plagiarism/scan-history', { pageNum, limit });

export const getScanStatus = (scanID: string) => httpGet('/plagiarism/scan-status', { scanID });

export const scanText = (text: string) => httpPost('/plagiarism/scan/text', { text });

export const updateScanStatus = (scanID: string, status: string) =>
  httpPut(`/plagiarism/scan/status/${scanID}`, { status });

export const deleteScan = (scanID: string) =>
  httpDelete(`/plagiarism/scan/${scanID}/delete-scan`, {});

export const getPlcPricing = () => httpGet('plagiarism/pricing');

export const rechargePlcCredits = (credits: number) =>
  httpPost('plagiarism/recharge-credits', { credits });
